<template>
    <v-dialog persistent max-width="700" :value="true">
      <v-card>
        <v-card-title>Update private note</v-card-title>
        <v-divider/>
        <v-card-text class="pb-0 pt-2 px-0">
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field label="Private note" v-model="privateNote" :rules="[fieldRules.maxLength(200)]" counter="1000" dense outlined/>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="$emit('done')">Cancel</v-btn>
          <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'UpdatePrivateNote',
  props: {
    item: {type:Object, required:true},
    operation: {type: String, required:true}
  },
  data() {
    return {
      privateNote: ''
    }
  },
  created() {
    this.privateNote = this.item.privateNote;
  },
  methods: {
    async save() {
      const results = await this.$apiCall(`mutation UpdatePrivateNote($id: ID!, $privateNote: String!) {
                                              ${this.operation}(id:$id, privateNote:$privateNote) {
                                                privateNote
                                              }
                                            }`,
                                          {id:this.item.id, privateNote:this.privateNote});
      if (!results.error) {
        this.item.privateNote = results.data[this.operation].privateNote;
        this.$emit('done');
        this.$store.commit('setError', {type:'success',message:`Updated private note`});
      }
    }
  }
}
</script>